import {createAction} from 'web-app/util/redux/famly-app-helpers';

const domain = 'PUBLIC_FUNDING_REPORT';

export const {action: fetchInitialReport} = createAction(
    `${domain}/FETCH_INITIAL_REPORT`,
    (institutionId, formData) => ({institutionId, formData}),
);

export const {
    action: fetchReport,
    success: fetchReportSuccess,
    failed: fetchReportFailed,
} = createAction(
    `${domain}/FETCH_REPORT`,
    (institutionId, formData) => ({institutionId, formData}),
    (table, csvLink, fundingLoopData) => ({
        table,
        csvLink,
        fundingLoopLink: fundingLoopData && (fundingLoopData.url || null),
    }),
);

export const {action: showFundingTypeModal} = createAction(
    `${domain}/SHOW_FUNDING_TYPE_MODAL`,
    (planId, selectedFundingTypes) => ({planId, selectedFundingTypes}),
);

export const {action: closeFundingTypeModal} = createAction(`${domain}/CLOSE_FUNDING_TYPE_MODAL`, () => ({}));

export const {
    action: changeFundingTypeForPlan,
    success: changeFundingTypeForPlanSuccess,
    failed: changeFundingTypeForPlanFailed,
} = createAction(`${domain}/CHANGE_FUNDING_TYPE_FOR_PLAN`, (planId, newFundingTypes) => ({planId, newFundingTypes}));

export const {action: reset} = createAction(`${domain}/RESET`);
